import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const TrainingTable = () => {
    return _jsx(React.Fragment, { children: "WIP - training table" });
};
export default TrainingTable;
